export default __webpack_public_path__ + "cbe560be483a8f72b8079ac6e6fba63e.png";